import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Eye } from "lucide-react";
import ShareButtons from "@/components/site/ShareButtons";
import Description from "@/components/text-editor/description";
import SEO from "@/components/SEO";

export default function BlogDetails() {
    const { id } = useParams();
    const [b, setB] = useState(null);
    useEffect(() => { api.get(`/blogs/${id}`).then((r) => setB(r.data)); window.scrollTo(0, 0); }, [id]);
    if (!b) return <div className="text-center py-20">Loading...</div>;
    return (
        <>
            <SEO title={b.title} description={b.excerpt} image={b.cover_image} />
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="text-xs font-bold tracking-wider text-brand-red uppercase">{b.category}</div>
            <h1 className="text-3xl md:text-4xl font-bold text-brand-navy mt-2 leading-tight">{b.title}</h1>
            <div className="flex items-center justify-between flex-wrap gap-3 mt-3">
                <div className="flex items-center gap-3 text-xs text-brand-navy/60">
                    <span>{b.author}</span>
                    <span className="inline-flex items-center gap-1"><Eye className="w-3 h-3" /> {b.views || 0} reads</span>
                </div>
            </div>
            {b.cover_image && <img src={b.cover_image} alt={b.title} className="w-full rounded-2xl mt-6 aspect-video object-cover" />}

            <article className="mt-8 prose prose-slate max-w-none text-brand-navy/85 leading-relaxed text-base break-words">
                <Description description={b.content} />
            </article>

            <div className="mt-12 pt-8 border-t border-brand-light">
                <ShareButtons title={b.title} />
            </div>
        </div>
        </>
    );
}
